module.exports = __webpack_public_path__ + "img/home.424d739f.svg";